module.exports = __webpack_public_path__ + "img/developersteve-pro.4a3587c7.jpg";